var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable max-statements */
import loadScript from '../../utils/loadScript';
import logger from '../../config/app.logger';
import { getExtendedLogger } from '../Logger';
import { FRESHCHAT_HOST, FRESHCHAT_WIDGET_URL, FRESHCHAT_WIDGET_CLASS, LOGGER_NAME, FRESHCHAT_WIDGET_ID_FOR_BERRY, FRESHCHAT_EVENT_NAME, MESSAGES, } from './constants';
import { getFreshchatWidgetStyle } from './style';
var log = getExtendedLogger(LOGGER_NAME, logger);
var noop = function () { return null; };
function checkFreshchatUserPresent() {
    return new Promise(function (resolve) {
        fcWidget.user.get(function (response) { return resolve(response.status !== 200); });
    });
}
function createFreshchatUser(config) {
    var name = config.name, email = config.email, userId = config.userId, companyId = config.companyId, learningSite = config.learningSite;
    fcWidget.user.setFirstName(name || userId);
    fcWidget.user.setEmail(email);
    fcWidget.user.setProperties({
        cname: companyId,
        lsLink: learningSite,
    });
}
function prepareOptionsFromConfig(config) {
    var freshchatId = config.id, freshchatRestoreId = config.restoreId, userId = config.userId, companyId = config.companyId, isBerryChatEnabled = config.isBerryChatEnabled, widgetUuid = config.widgetUuid;
    var fcConfig = {
        token: freshchatId,
        host: FRESHCHAT_HOST,
        siteId: companyId,
        externalId: userId + "|" + companyId,
        restoreId: freshchatRestoreId ? freshchatRestoreId : null,
        config: {
            cssNames: {
                widget: FRESHCHAT_WIDGET_CLASS,
            },
            headerProperty: {
                hideChatButton: isBerryChatEnabled,
            },
        },
    };
    if (isBerryChatEnabled) {
        fcConfig.widgetUuid = FRESHCHAT_WIDGET_ID_FOR_BERRY;
        fcConfig.config.content = {
            placeholders: {
                reply_field: MESSAGES.REPLY_FIELD_PLACEHOLDER,
                csat_reply: MESSAGES.CSAT_REPLY_PLACEHOLDER,
            },
            headers: {
                csat_question: MESSAGES.CSAT_QUESTION,
            },
        };
    }
    if (widgetUuid) {
        fcConfig.widgetUuid = widgetUuid;
    }
    return fcConfig;
}
function attachEventHandlers(_a, isBerryChatEnabled) {
    var _b;
    var _c = _a.onUserCreation, onUserCreation = _c === void 0 ? noop : _c, _d = _a.onCsatReceived, onCsatReceived = _d === void 0 ? noop : _d, _e = _a.onCsatUpdated, onCsatUpdated = _e === void 0 ? noop : _e, _f = _a.onMessageSent, onMessageSent = _f === void 0 ? noop : _f, _g = _a.onMessageReceived, onMessageReceived = _g === void 0 ? noop : _g, _h = _a.onResolve, onResolve = _h === void 0 ? noop : _h, _j = _a.onWidgetClosed, onWidgetClosed = _j === void 0 ? noop : _j, _k = _a.onWidgetLoaded, onWidgetLoaded = _k === void 0 ? noop : _k;
    fcWidget.on(FRESHCHAT_EVENT_NAME.WIDGET_USER_CREATED, onUserCreation);
    if (isBerryChatEnabled) {
        var eventHandlersConfig = (_b = {},
            _b[FRESHCHAT_EVENT_NAME.WIDGET_CLOSED] = onWidgetClosed,
            _b[FRESHCHAT_EVENT_NAME.WIDGET_CSAT_RECEIVED] = onCsatReceived,
            _b[FRESHCHAT_EVENT_NAME.WIDGET_CSAT_UPDATED] = onCsatUpdated,
            _b[FRESHCHAT_EVENT_NAME.WIDGET_CONVERSATION_RESOLVED] = onResolve,
            _b[FRESHCHAT_EVENT_NAME.WIDGET_MESSAGE_SENT] = onMessageSent,
            _b[FRESHCHAT_EVENT_NAME.WIDGET_MESSAGE_RECEIVED] = onMessageReceived,
            _b[FRESHCHAT_EVENT_NAME.WIDGET_LOADED] = onWidgetLoaded,
            _b);
        Object.entries(eventHandlersConfig).forEach(function (_a) {
            var _b = __read(_a, 2), eventName = _b[0], eventHandler = _b[1];
            fcWidget.on(eventName, eventHandler);
        });
    }
}
function loadFreshchat(config, eventHandlers) {
    if (eventHandlers === void 0) { eventHandlers = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var freshchatId, options, isBerryChatEnabled, isAvailable;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    freshchatId = config.id;
                    if (!freshchatId) {
                        log('id(freshchatId) not present, skipping loading phase');
                        return [2 /*return*/];
                    }
                    log('loading with id %s', freshchatId);
                    return [4 /*yield*/, loadScript({
                            url: FRESHCHAT_WIDGET_URL,
                            defer: true,
                        })];
                case 1:
                    _a.sent();
                    if (!fcWidget) {
                        log('not loaded, skipping initialisation phase');
                        return [2 /*return*/];
                    }
                    options = prepareOptionsFromConfig(config);
                    log('initialising with options %o', options);
                    fcWidget.init(options);
                    isBerryChatEnabled = config.isBerryChatEnabled;
                    if (!eventHandlers) {
                        log('no eventhandlers provided, skipping event handlers phase');
                    }
                    else {
                        attachEventHandlers(eventHandlers, isBerryChatEnabled);
                    }
                    log('checking user existance');
                    return [4 /*yield*/, checkFreshchatUserPresent()];
                case 2:
                    isAvailable = _a.sent();
                    if (!isAvailable) {
                        log('user not available, creating user');
                        createFreshchatUser(config);
                    }
                    else {
                        log('user available');
                    }
                    return [2 /*return*/];
            }
        });
    });
}
var clearFreshchatUser = function () {
    try {
        log('clearing user');
        fcWidget.user.clear();
        log('successfully cleaned');
    }
    catch (error) {
        log('clearing user failed');
        console.error(error); //eslint-disable-line no-console
    }
};
var openChatbox = function () {
    try {
        fcWidget.open();
    }
    catch (error) {
        console.error(error); //eslint-disable-line no-console
    }
};
var closeChatbox = function () {
    try {
        fcWidget.close();
    }
    catch (error) {
        console.error(error); //eslint-disable-line no-console
    }
};
var toggleFreshchat = function (_a) {
    var hideButton = _a.hideButton, _b = _a.hideChatbox, hideChatbox = _b === void 0 ? true : _b;
    try {
        fcWidget === null || fcWidget === void 0 ? void 0 : fcWidget.setConfig({ headerProperty: { hideChatButton: hideButton } });
        !hideChatbox && openChatbox();
    }
    catch (error) {
        console.error(error); //eslint-disable-line no-console
    }
};
var updateFreshchatProperties = function (data) {
    try {
        fcWidget === null || fcWidget === void 0 ? void 0 : fcWidget.conversation.setConversationProperties({
            cf_berry_chat_link: data === null || data === void 0 ? void 0 : data.berryAdminChatUrl,
            cf_lslink: (data === null || data === void 0 ? void 0 : data.learningSite) || window.location.hostname,
        });
    }
    catch (error) {
        console.error(error); //eslint-disable-line no-console
    }
};
var isFreshchatInitialized = function () { return fcWidget === null || fcWidget === void 0 ? void 0 : fcWidget.isInitialized(); };
export { closeChatbox, loadFreshchat, clearFreshchatUser, openChatbox, toggleFreshchat, updateFreshchatProperties, isFreshchatInitialized, getFreshchatWidgetStyle, };
//# sourceMappingURL=helpers.js.map